import { HttpWrapper } from '../httpWrapper';
import { sqlQuery } from './api';

export async function getLibraryCount(http: HttpWrapper): Promise<number> {
    const query = `
        SELECT count(1) as libraryCount
        FROM _library
        WHERE IsValid = 1
    `;

    const response = await sqlQuery(http, {
        query
    });

    return response.data[0].libraryCount as number;
}
